import { httpGet } from '../../../utils/api.utils';
import { removePlusSign } from '../../../utils/helpers.utils';
import { CIRCUIT_CATEGORIES } from '../../../utils/constant.utils';
import {
    getMobileItems, getHomeItems, setMobileSearchValue, setHomeSearchValue,
    clearMobileSubscriptionItems, clearHomeSubscriptionItems, clearMobileSearchValue,
    clearHomeSearchValue, setItemPrimaryMobile, setItemPrimaryHome,
    getOtherSubscribersUnderLineManager, setSelectedUser, clearSelectedUser,
    setActiveCircuit, clearActiveCircuit, setTabKey, setMobileIsFetching,
    setHomeIsFetching, setIsPersonal, setSubscription, setCurrentToggleTab, setNoSubscriptionFound,
    setSubscribers } from '../../../constants/model-reducers/external/side-nav-menu/side-nav-menu.settings';

const initialState = {
    isPersonal: false,
    activeTabKey: 1,
    mobileItems: {
        Data: [],
        Pagination: {
            HasNext: true,
            HasPrevious: false,
        },
        isBeforeFetch: true,
        isFetching: false,
    },
    mobileSearchValue: '',
    homeItems: {
        Data: [],
        Pagination: {
            HasNext: true,
            HasPrevious: false,
        },
        isBeforeFetch: true,
        isFetching: false,
    },
    homeSearchValue: '',
    otherSubscribersList: [],
    subscribers: [],
    selectedUser: {
        EmployeeId: null,
        FullName: '',
        EId: '',
        EmailAddress: '',
        ContactNumber: '',
        Country: '',
        Location: '',
    },
    activeCircuit: {
        CircuitId: null,
        IsPrimaryNumber: false,
        UserId: null,
    },
    subscriptionItems: {
        isFetching: false
    },
    selectedToggleTab: "0",
    isNoSubscriptionFound: false
};

export const sideNavMenuActions = {
    fetchSubscriptionItems: (isMobile, index) => async (dispatch, state) => {
        const sideNavMenuState = state().sideNavMenu;
        const empId = sideNavMenuState.selectedUser?.EmployeeId ?? sessionStorage.EmployeeID;

        let searchString = isMobile
            ? sideNavMenuState.mobileSearchValue
            : sideNavMenuState.homeSearchValue;

        const currentItems = isMobile
            ? sideNavMenuState.mobileItems.Data
            : sideNavMenuState.homeItems.Data;

        const pagination = isMobile
            ? sideNavMenuState.mobileItems.Pagination
            : sideNavMenuState.homeItems.Pagination;

        const type = isMobile ? getMobileItems : getHomeItems;
        const isFetchingType = isMobile ? setMobileIsFetching : setHomeIsFetching;

        dispatch({
            type: isFetchingType,
            isFetching: true,
        });

        const sanitizedSearch = removePlusSign(searchString);

        const res = await httpGet(`external/nav/getSubscriptions/${parseInt(empId, 10)}/${index}/${isMobile}/${sanitizedSearch}`);

        const combinedItems = {
            Data: res.ok === false ? [...currentItems] : [...res.Data],
            Pagination: res.ok === false ? pagination : res.Pagination,
            isBeforeFetch: false,
        };

        dispatch({
            type: type,
            items: combinedItems,
        });

        dispatch({
            type: isFetchingType,
            isFetching: false,
        });

        if (isFetchingType === setHomeIsFetching) {
            if (combinedItems.Data.length === 0) {
                dispatch({
                    type: setNoSubscriptionFound,
                    data: true,
                });
            } else {
                dispatch({
                    type: setNoSubscriptionFound,
                    data: false,
                });
            }
        }

        return true;
    },
    setSearchValue: (isMobile, searchValue) => (dispatch) => {
        const type = isMobile ? setMobileSearchValue : setHomeSearchValue;

        dispatch({
            type: type,
            searchValue: searchValue,
        });
    },
    clearSubscriptionItems: (isMobile) => (dispatch) => {
        const type = isMobile ? clearMobileSubscriptionItems : clearHomeSubscriptionItems;

        dispatch({
            type: type,
        });
    },
    clearSearchValue: (isMobile) => (dispatch) => {
        const type = isMobile ? clearMobileSearchValue : clearHomeSearchValue;

        dispatch({
            type: type,
        });
    },
    setActiveItemPrimary: (circuit) => (dispatch) => {
        const type = circuit.CircuitCategoryId === CIRCUIT_CATEGORIES.mobile ? setItemPrimaryMobile : setItemPrimaryHome;

        dispatch({
            type: type,
            circuitId: circuit.CircuitId,
            isPrimaryNumber: circuit.IsPrimaryNumber,
            circuitCategoryId: circuit.CircuitCategoryId,
        });
    },
    fetchActiveSubscribers: (employeeId) => async (dispatch) => {
        const otherSubscribersList = await httpGet(`external/otherSubscribers/getFirstLevelSubscribers/${employeeId}`);

        dispatch({
            type: getOtherSubscribersUnderLineManager,
            otherSubscribersList: Object.keys(otherSubscribersList).length > 0 ? otherSubscribersList : [],
        });
    },
    setSelectedUser: (selectedUser) => async (dispatch) => {
        dispatch({
            type: setSelectedUser,
            selectedUser: selectedUser,
        });
    },
    clearSelectedUser: () => (dispatch) => {
        dispatch({
            type: clearSelectedUser,
        });
    },
    setActiveCircuit: (activeCircuit) => (dispatch) => {
        dispatch({
            type: setActiveCircuit,
            activeCircuit: activeCircuit,
        });
    },
    clearActiveCircuit: () => (dispatch) => {
        dispatch({
            type: clearActiveCircuit,
        });
    },
    setActiveTabKey: (tabKey) => (dispatch) => {
        dispatch({type: setTabKey, data: tabKey});
    },
    setIsPersonal: (isPersonal) => (dispatch) => {
        dispatch({ type: setIsPersonal, data: isPersonal});
    },
    onChangeUserSearch: (val) => async (dispatch, state) => {
        const selected = state().sideNavMenu.selectedUser.FullName;

        if (!val || val === selected) return null;

        const res = await httpGet(`external/autosuggest/getEmployees/${sessionStorage.EmployeeID}/${sessionStorage.UserRoleID}/${sessionStorage.IsExecutive}/${sessionStorage.IsKeyUser}/${val}/false/0/true`);

        dispatch({
            type: getOtherSubscribersUnderLineManager,
            otherSubscribersList: res,
        });

        return res ?? null;
    },
    setCurrentToggleTab: (curToggleTab) => (dispatch) => {
        dispatch({ type: setCurrentToggleTab, data: curToggleTab });
    },
    fetchAllSubscribers: () => async (dispatch, state) => {
        const res = await httpGet(`external/autosuggest/getAllSubscribers/${sessionStorage.EmployeeID}/${sessionStorage.Idhr}/${sessionStorage.UserRoleID}`);

        dispatch({
            type: setSubscribers,
            subscribers: res
        });

        return res ?? [];
    }
};

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case getMobileItems:
            return {
                ...state,
                mobileItems: action.items,
            };
        case getHomeItems:
            return {
                ...state,
                homeItems: action.items,
            };
        case setMobileSearchValue:
            return {
                ...state,
                mobileSearchValue: action.searchValue,
            };
        case setHomeSearchValue:
            return {
                ...state,
                homeSearchValue: action.searchValue,
            };
        case clearMobileSubscriptionItems:
            return {
                ...state,
                mobileItems: initialState.mobileItems,
            };
        case clearHomeSubscriptionItems:
            return {
                ...state,
                homeItems: initialState.homeItems,
            };
        case clearMobileSearchValue:
            return {
                ...state,
                mobileSearchValue: initialState.mobileSearchValue,
            };
        case clearHomeSearchValue:
            return {
                ...state,
                homeSearchValue: initialState.homeSearchValue,
            };
        case setItemPrimaryMobile:
            let mobileIndex;
            var mobileData = state.mobileItems.Data.map((item, i) => {
                if (item.CircuitId === action.circuitId) (mobileIndex = i);
                return {
                    ...item,
                    IsPrimaryNumber: item.CircuitId === action.circuitId ? action.isPrimaryNumber : !action.isPrimaryNumber,
                };
            });
            mobileData.unshift(mobileData.splice(mobileIndex, 1)[0]);
            return {
                ...state,
                mobileItems: {
                    ...state.mobileItems,
                    Data: mobileData,
                },
            };
        case setItemPrimaryHome:
            let homeIndex;
            var homeData = state.homeItems.Data.map((item, i) => {
                if (item.CircuitId === action.circuitId) (homeIndex = i);
                return {
                    ...item,
                    IsPrimaryNumber:
                        item.CircuitId === action.circuitId
                            ? action.isPrimaryNumber
                            : item.CircuitCategoryId === action.circuitCategoryId
                                ? !action.isPrimaryNumber
                                : item.IsPrimaryNumber,
                };
            });
            homeData.unshift(homeData.splice(homeIndex, 1)[0]);
            return {
                ...state,
                homeItems: {
                    ...state.homeItems,
                    Data: homeData,
                },
            };
        case getOtherSubscribersUnderLineManager:
            return {
                ...state,
                otherSubscribersList: action.otherSubscribersList,
            };
        case setSelectedUser:
            return {
                ...state,
                selectedUser: action.selectedUser,
            };
        case clearSelectedUser:
            return {
                ...state,
                selectedUser: initialState.selectedUser,
            };
        case setActiveCircuit:
            return {
                ...state,
                activeCircuit: action.activeCircuit,
            };
        case clearActiveCircuit:
            return {
                ...state,
                activeCircuit: initialState.activeCircuit,
            };
        case setTabKey:
            return {
                ...state,
                activeTabKey: action.data,
            };
        case setIsPersonal:
            return {
                ...state,
                isPersonal: action.data,
            };
        case setMobileIsFetching:
            return {
                ...state,
                mobileItems: {
                    ...state.mobileItems,
                    isFetching: action.isFetching,
                },
            };
        case setHomeIsFetching:
            return {
                ...state,
                homeItems: {
                    ...state.homeItems,
                    isFetching: action.isFetching,
                },
            };
        case setSubscription:
            return {
                ...state,
                subscriptionItems: {
                    ...state.subscriptionItems,
                    isFetching: action.isFetching,
                },
            };
        case setCurrentToggleTab:
            return {
                ...state,
                selectedToggleTab: action.data,
            };
        case setNoSubscriptionFound:
            return {
                ...state,
                isNoSubscriptionFound: action.data,
            };
        case setSubscribers:
            return {
                ...state,
                subscribers: action.subscribers
            }
        default:
            return state;
    }
};
